module.exports = __webpack_public_path__ + "static/media/acrobat.4ce3f7c5.svg";